import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { APP_CONFIG } from '../../core';
import { CaseService, ModelService } from '../../services';
import { BaseComponent } from '../base';


/**
* Modal component to confirm before exit from ray site.
*/
@Component({
	selector: 'app-closure-modal',
	templateUrl: './closure-modal.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class ClosureModalComponent extends BaseComponent {

	public activeModal = inject(NgbActiveModal);
	private readonly config = inject(APP_CONFIG);
	private readonly caseSrv = inject(CaseService);
	private readonly modelSrv = inject(ModelService);

	isReadOnly = toSignal(this.caseSrv.isReadOnly());


	/**
	* Close site without save current state.
	*/
	closeWithoutSave(): void {
		globalThis.location.href = this.config.patplanSite;
	}

	/**
	* Close site and save current state.
	*/
	closeWithSave(): void {
		if (!this.isReadOnly()) {
			const currentCase = this.canvasSrv.currentCase!;
			this.modelSrv.persistModel(currentCase.id, currentCase.userGuid).subscribe(() => globalThis.location.href = this.config.patplanSite);
		}
	}

}
